import { Link, useLocation } from 'react-router-dom'
import { Button, Drawer } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { useDialog } from 'src/shared/hooks'
import { useHomeAndScroll } from 'src/shared/hooks/useHomeandScroll'
import type SwiperCore from 'swiper'

import { useAuth } from 'src/auth/authProvider'

import PromotionBanner from '../PromotionBanner'

import Search from './Search'
import Menu from './Menu'
import { CartBtn } from './CartBtn'
import { UserPopover } from './UserPopover'
import { QuoteButton } from './QuoteButton'
import { MenuMobile } from './MenuMobile'

import { DrawerHeaderStyled, MenuIconStyled, MenuIconStyledHome } from './CartBtn/styles'
import { NavbarBase, NavbarTransparentStyled, NavbarScrolledStyled } from './styles'

interface IProps {
  swiperInstance?: SwiperCore
}
const Navbar = (props: IProps) => {
  const modalReq = useDialog()
  const location = useLocation()
  const { user } = useAuth()
  const { open, handleClose, handleOpen } = useDialog()
  const { isHome, scrolled } = useHomeAndScroll()

  const NavbarComponent = isHome && !scrolled ? NavbarTransparentStyled : NavbarScrolledStyled
  const MenuStyled = isHome && !scrolled ? MenuIconStyledHome : MenuIconStyled

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <PromotionBanner />

      <NavbarComponent>
        <MenuStyled>
          <MenuOutlined onClick={handleOpen} />
        </MenuStyled>
        <Link className="logo-desktop" to="/">
          <img
            src={isHome && !scrolled ? '/logos/logo-white.svg' : '/logos/logo.svg'}
            width="140"
            height="40"
            alt="Equip"
            loading="lazy"
          />
        </Link>
        <Link className="logo-mobile" to="/">
          <img
            src={
              isHome && !scrolled ? '/logos/logowhite-responsive.svg' : '/logos/logoresponsive.svg'
            }
            width="40"
            height="40"
            alt="Equip"
            loading="lazy"
          />
        </Link>
        <Menu modalReq={modalReq} swiperInstance={props.swiperInstance} />
        <Search />

        {user?.name ? (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
            <CartBtn modalReq={modalReq} />
            <UserPopover />
            <QuoteButton modalReq={modalReq} handleClose={handleClose} />
          </div>
        ) : (
          <div className="grid">
            <CartBtn modalReq={modalReq} />
            <UserPopover />
            <QuoteButton modalReq={modalReq} handleClose={handleClose} />
          </div>
        )}

        <Drawer
          title={
            <DrawerHeaderStyled>
              <Link className="logo-desktop" to="/">
                <img className="logo" src="/logos/logo.svg" alt="Logo de Equip" loading="lazy" />
              </Link>
              <Button onClick={handleClose}>Cerrar</Button>
            </DrawerHeaderStyled>
          }
          placement="left"
          closable={false}
          onClose={handleClose}
          open={open}
          key="left"
        >
          <MenuMobile modalReq={modalReq} handleClose={handleClose} />
        </Drawer>
      </NavbarComponent>
    </div>
  )
}

export default Navbar
